'use client'

import FloatingAdmission from "@/components/floating-admission";
import { Footer } from "@/components/landing/footer";
import { Header } from "@/components/landing/header";

const LandingLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main>{children}</main>
      <FloatingAdmission />
      <Footer />
    </div>
  );
};

export default LandingLayout;
